// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CrossRateCalculationType, CrossRateType } from './CrossRateCalculationType';
export class CrossRateDataValue {
    constructor() {
        this.IsReverse = CrossRateType.Simple;
        this.Price = NaN;
        this.Bid = NaN;
        this.Ask = NaN;
        this.DefaultPriceType = CrossRateCalculationType.BID_ASK_2;
        this.InstrumentId = null;
        this.InstrumentTypeId = null;
        this.PointSize = null;
        this.SecondCrossRateDataValue = null;
    }
}
